import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, useHistory } from 'react-router-dom';
import style from './Home.scss';

import IndexView from './View/IndexView';
import RegisterView from './View/RegisterView';
import MeetingView from './View/MeetingView';
import UserIndexView from './View/UserIndexView';
import UserSettingView from './View/UserSettingView';
import BindWechatView from './View/BindWechatView';
import PayWayView from './View/PayWayView';
import Article from './View/article';
import { api } from '../../common/app';
import { wxShare } from '../../common/utils/wx-share';
import { MeetMenuList } from '../../common/common';
import HotelFormView from './View/FormView/HotelFormView';
import RegisterFormView from './View/FormView/RegisterFormView';
import PlainFormView from './View/FormView/PlainFormView';
import JourneyFormView from './View/FormView/JourneyFormView';
import Advertisement from '../../components/advertisement';
import PayView from '../Pay'

export function Home(homeProps: any) {
  const { refreshProps } = homeProps;
  const history = useHistory();
  const [meetid, setMeetid] = useState('');

  useEffect(() => {
    // refreshProps
    let hash = window.location.hash;
    let hasharray = hash.split("/");
    const meetingid = hasharray[hasharray.length - 1];
    if (meetingid !== meetid) {
      refreshProps();
    }
  }, [window.location.hash])

  useEffect(() => {

    let hash = window.location.hash;
    let hasharray = hash.split('/');
    const meetingid: any = hasharray[hasharray.length - 1];

    setMeetid(meetingid);
    (api as any).getMeetingIndex(meetingid).then(
      (res: any) => {
        if (res.code === 200) {
          console.log('res.result', res.result);
          document.title = res.result.title ?? '会佰分';
        }
      },
      (err: any) => {
        console.log(err);
      }
    );

    /**
     * 在全局进行微信config配置
     */
    wxShare.getConfig(meetingid);
  }, []);

  return (
    <div className={style.Box}>
      <div className={style.ContentBox}>
        <Switch>
          {/* 首页 */}
          <Route
            path="/home/index/:id"
            render={(props: any) => {
              // document.title = "会佰分-首页";
              return <IndexView {...props} {...homeProps} />;
            }}
          />
          <Route
            path="/home/register/:id/:phone"
            render={(props: any) => {
              // document.title = "完善您的信息";
              return <RegisterView {...props} />;
            }}
          />
          {/* 酒店注册 */}
          <Route
            path="/home/register/:id"
            render={(props: any) => {
              // document.title = "会佰分-首页";
              return <RegisterFormView {...props} {...homeProps} />;
            }}
          />
          {/* 酒店注册 */}
          <Route
            path="/home/hotel/:id"
            render={(props: any) => {
              // document.title = "会佰分-首页";
              return <HotelFormView {...props}{...homeProps} />;
            }}
          />
          {/* 接送机注册 */}
          <Route
            path="/home/plain/:id"
            render={(props: any) => {
              return <PlainFormView {...props} {...homeProps} />;
            }}
          />
          {/* 行程注册 */}
          <Route
            path="/home/joruney/:id"
            render={(props: any) => {
              return <JourneyFormView {...props} {...homeProps} />;
            }}
          />
          <Route
            path="/home/meeting/:id"
            render={(props: any) => {
              // document.title = "会佰分";
              return <MeetingView {...props} />;
            }}
          />
          <Route
            path="/home/user/:id"
            render={(props: any) => {
              // document.title = "我的";
              return <UserIndexView {...props} />;
            }}
          />
          <Route
            path="/home/setting/:id"
            render={(props: any) => {
              // document.title = "我的";
              return <UserSettingView {...props} />;
            }}
          />
          <Route
            path="/home/bindwx/:id"
            render={(props: any) => {
              // document.title = "会佰分-一步注册";
              return <BindWechatView {...props} />;
            }}
          />
          {/* <Route
            path="/home/pay/:id"
            render={(props: any) => {
              // document.title = "会佰分";
              return <PayWayView {...props} />;
            }}
          /> */}
          <Route
            path="/home/pay/:id"
            render={(props: any) => {
              // document.title = "会佰分";
              return <PayView {...props} />;
            }}
          />
          <Route
            path="/home/article/:meetid/:id"
            render={(props: any) => {
              // document.title = "会佰分-文章详情";
              return <Article {...props} />;
            }}
          />
          <Redirect from="/home" to="/home/index/null" />
        </Switch>
      </div>
      {/* <div className={[style.BotNav,'childcenter'].join(' ')}>

        <div className={[style.IconBox,'childcenter childcolumn'].join(' ')} onClick={()=>{window.location.hash='#/home/index/'+this.state.meetingid}}>
          <div className={style.IconImage}>
            <img src={homeicon} alt=""/>
          </div>
          <div className={style.IconText}>
            <p>首页</p>
          </div>
        </div>
        <div className={[style.IconBox,'childcenter childcolumn'].join(' ')} onClick={()=>{window.location.hash='#/home/meeting/'+this.state.meetingid}}>
          <div className={style.IconImage}>
            <img src={infoicon} alt=""/>
          </div>
          <div className={style.IconText}>
            <p>大会信息</p>
          </div>
        </div>
        <div className={[style.IconBox,'childcenter childcolumn'].join(' ')} onClick={()=>{window.location.hash='#/home/user/'+this.state.meetingid}}>
          <div className={style.IconImage}>
            <img src={myicon} alt=""/>
          </div>
          <div className={style.IconText}>
            <p>我的</p>
          </div>
        </div>

      </div> */}

      <Advertisement meetid={meetid} />
    </div>
  );
}
export default Home;
